export default "__VITE_ASSET__CM7iCicL__"